import { Styles } from '@monkvision/types';

export const styles: Styles = {
  pdfButton: {
    borderRadius: '9px',
    width: 'fit-content',
  },
};
